import styled from "styled-components";
import checkMark from "../assets/icons/check-mark.svg";

const FilteringStyles = styled.div`
  .filters-header--mobile {
    display: none;
  }

  .done-filtering-btn--mobile {
    display: none;
  }

  .two-col-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    padding: 0 18px;
  }

  .search-container--mobile {
    display: none;
  }

  .instructions {
    border-radius: 30px;
    /* border: 1px solid white; */
    box-shadow: 0 0 8px 0px rgba(0, 0, 0, 0.1);

    padding: 20px 18px 24px;
    margin-top: 20px;
    margin-bottom: 8px;
    background: white;
    width: 336px;
  }

  .filter-sort-bar {
    top: 90px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    &__container {
      position: relative;
      padding-bottom: 12px;
    }

    &__instructions {
      font-family: var(--header-font) !important;
      font-weight: normal !important;
      font-size: 30px;
      margin-bottom: 8px;
      line-height: 36px;

      &-2 {
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 20px;
        max-width: 300px;
      }
    }
  }

  .num-of-filters {
    display: none;
  }

  .num-of-selected {
    font-family: var(--header-font-bold);
    font-size: 15px;
    padding-left: 8px;
    color: var(--off-black);
  }

  .down-arrow {
    position: relative;
    right: 4px;
    transition: 0.15s all;
    top: 1px;
  }

  .sort-bar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .dropdown-search {
    border: 1px solid #cdcdcd;
    border-radius: 24px;
  }

  .filter-dropdown {
    background: white;
    /* border: 1px solid white; */
    border-radius: 30px;
    margin-bottom: 8px;
    /* padding-bottom: 20px; */
    box-shadow: 0 0 8px 0px rgba(0, 0, 0, 0.1);
  }

  .sustainable-dropdown-label {
    font-family: var(--header-font) !important;
    font-weight: normal !important;
    font-size: 20px !important;
    color: var(--off-black) !important;
    cursor: default !important;
    padding-top: 22px !important;
    margin-bottom: 8px !important;
    height: auto !important;
    line-height: 26px !important;
    width: 300px;
    border-radius: 0 !important;
  }

  #sustainable-dropdown {
    padding: 12px 0 12px;
  }

  .dropdown-examples {
    position: relative;
    top: -1px;
    font-size: 14px;
    line-height: 18px;
    padding-bottom: 2px;
    color: #a8a8a8;
    padding-left: 12px;
    font-family: var(--body-font);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .label-text {
    width: 270px !important;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    height: 57px !important;
    color: #a8a8a8;
  }

  .label-title {
    font-family: var(--header-font);
    font-weight: normal;
    font-size: 20px;
    color: var(--off-black);
  }

  .dropdown,
  .dropdown-search {
    z-index: 10000;

    &:first-child {
      margin-left: 0;
    }

    &-check-list:focus {
      outline: none;
    }

    &-learn-more {
      border-top: 2px solid var(--light-gray);
      font-size: 16px;
      line-height: 20px;
      padding: 12px 13px 0 15px;
      margin: 0px 4px;
      margin-top: 60px;
    }

    &-learn-more-link {
      color: var(--cornflower);
      text-decoration: none;
    }

    &-label {
      cursor: pointer;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0;
      position: relative;
      width: 300px;
      font-size: 14px;
      left: 18px;
      height: 57px;
      line-height: 57px;
      border-radius: 100px;
      margin: 0;
      font-weight: normal !important;
    }

    &-sustainable {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 16px;
    }

    &-sublabel {
      font-size: 16px;
      line-height: 22px;
      padding: 0 10px 0 18px !important;
      margin-bottom: 12px;
    }

    &-subcategory {
      font-size: 16px;
      color: #8c8c8c;
      padding: 0 16px 0 18px !important;
      margin-top: 10px;
      margin-bottom: 12px;

      &:first-child {
        margin-top: 0;
      }
    }
  }

  #search-form,
  #search-form--mobile {
    width: 300px;
  }

  #see-all {
    display: inline-block;
    cursor: pointer;
    padding: 0;
    padding-bottom: 5px;
    font-size: 16px;
    line-height: normal;
    text-align: center;
    border: none;
    border-bottom: 1px #231f20 solid;
    z-index: 10;
  }

  .list {
    display: none;
    margin: 0;
  }

  #sustainable-filter-toggle:checked ~ form > .list,
  #cuisine-filter-toggle:checked ~ form > .list,
  #dining-filter-toggle:checked ~ form > .list,
  #price-filter-toggle:checked ~ form > .list,
  #neighborhood-filter-toggle:checked ~ form > .list,
  #vibe-filter-toggle:checked ~ form > .list,
  #lifestyle-filter-toggle:checked ~ form > .list,
  #meal-filter-toggle:checked ~ form > .list,
  #sustainable-filter-toggle--mobile:checked ~ form > .list,
  #cuisine-filter-toggle--mobile:checked ~ form > .list,
  #dining-filter-toggle--mobile:checked ~ form > .list,
  #price-filter-toggle--mobile:checked ~ form > .list,
  #neighborhood-filter-toggle--mobile:checked ~ form > .list,
  #vibe-filter-toggle--mobile:checked ~ form > .list,
  #lifestyle-filter-toggle--mobile:checked ~ form > .list,
  #meal-filter-toggle--mobile:checked ~ form > .list {
    display: block;
    padding: 6px 0 14px;
  }

  #sustainable-filter-toggle:checked ~ label,
  #cuisine-filter-toggle:checked ~ label,
  #dining-filter-toggle:checked ~ label,
  #price-filter-toggle:checked ~ label,
  #vibe-filter-toggle:checked ~ label,
  #neighborhood-filter-toggle:checked ~ label,
  #lifestyle-filter-toggle:checked ~ label,
  #meal-filter-toggle:checked ~ label,
  #sustainable-filter-toggle--mobile:checked ~ label,
  #cuisine-filter-toggle--mobile:checked ~ label,
  #dining-filter-toggle--mobile:checked ~ label,
  #price-filter-toggle--mobile:checked ~ label,
  #vibe-filter-toggle--mobile:checked ~ label,
  #neighborhood-filter-toggle--mobile:checked ~ label,
  #lifestyle-filter-toggle--mobile:checked ~ label,
  #meal-filter-toggle--mobile:checked ~ label {
    padding-top: 4px !important;
    background: white;
    box-shadow: none;
  }

  .check {
    &-label {
      font-size: 16px;
      line-height: 20px;
      padding: 0 0 0 28px;
      display: inline-block;
      max-width: 147px;
      cursor: pointer;

      &--values {
        cursor: pointer;
        display: block;
        height: 40px;
        font-size: 16px;
        background: var(--neon-yellow);
        line-height: 38px;
        width: 145px;
        border-radius: 30px;
        padding-left: 11px;

        &:before {
          content: "";
          margin-right: 6px;
          display: inline-block;
          vertical-align: text-top;
          width: 20px;
          height: 20px;
          border: 1px solid var(--footer-med-gray);
          border-radius: 30px;
          /* position: absolute; */
          background: white;
          /* left: 0;
          top: 0px; */
        }
      }

      &--disabled {
        color: #8b8b8b !important;
      }

      &:before {
        content: "";
        margin-right: 6px;
        display: inline-block;
        vertical-align: text-top;
        width: 20px;
        height: 20px;
        border: 1px solid #afafaf;
        border-radius: 2px;
        position: absolute;
        left: 0;
        top: 0px;
      }
    }

    &-sublabel {
      font-size: 14px;
      line-height: normal;
      color: #8c8c8c;
      padding: 0px 0px 0px 0px;
      display: block;
    }

    &-item {
      margin-bottom: 14px;
      position: relative;
      display: flex;
      flex: 1 1 147px;
      max-width: 147px;

      &:nth-child(odd) {
        padding-right: 6px;
      }

      &--values {
        display: flex;
        margin-bottom: 12px;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        flex: 1 1 145px;
        max-width: 145px;

        &:nth-child(odd) {
          margin-right: 6px;
        }
      }
    }
  }

  .cuisine-check,
  .sustainable-check,
  .meal-check,
  .signup-check,
  .lifestyle-check,
  .price-check,
  .vibe-check,
  .neighborhood-check,
  .dining-check {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  .cuisine-check:checked + label:before,
  .meal-check:checked + label:before,
  .lifestyle-check:checked + label:before,
  .dining-check:checked + label:before,
  .price-check:checked + label:before,
  .vibe-check:checked + label:before,
  .neighborhood-check:checked + label:before,
  .sustainable-check:checked + label:before,
  .signup-check:checked + label:before {
    background: white;
  }

  .cuisine-check:checked + label:after,
  .meal-check:checked + label:after,
  .signup-check:checked + label:after,
  .lifestyle-check:checked + label:after,
  .price-check:checked + label:after,
  .vibe-check:checked + label:after,
  .neighborhood-check:checked + label:after,
  .dining-check:checked + label:after {
    position: absolute;
    left: 3px !important;
    top: -3px;
    content: url(${checkMark});
    z-index: 99999;
  }

  .sustainable-check:checked + label:after {
    position: absolute;
    left: 14px !important;
    top: 1px;
    content: url(${checkMark});
    z-index: 99999;
  }

  #sustainable-filter-toggle:checked ~ label > .down-arrow,
  #cuisine-filter-toggle:checked ~ label > .down-arrow,
  #dining-filter-toggle:checked ~ label > .down-arrow,
  #price-filter-toggle:checked ~ label > .down-arrow,
  #vibe-filter-toggle:checked ~ label > .down-arrow,
  #neighborhood-filter-toggle:checked ~ label > .down-arrow,
  #lifestyle-filter-toggle:checked ~ label > .down-arrow,
  #meal-filter-toggle:checked ~ label > .down-arrow,
  #sustainable-filter-toggle--mobile:checked ~ label > .down-arrow,
  #cuisine-filter-toggle--mobile:checked ~ label > .down-arrow,
  #dining-filter-toggle--mobile:checked ~ label > .down-arrow,
  #price-filter-toggle--mobile:checked ~ label > .down-arrow,
  #vibe-filter-toggle--mobile:checked ~ label > .down-arrow,
  #neighborhood-filter-toggle--mobile:checked ~ label > .down-arrow,
  #lifestyle-filter-toggle--mobile:checked ~ label > .down-arrow,
  #meal-filter-toggle--mobile:checked ~ label > .down-arrow {
    transform: scaleY(-1) translateY(-3px);
  }

  #cuisine-filter-toggle:checked ~ label > span > .dropdown-examples,
  #dining-filter-toggle:checked ~ label > span > .dropdown-examples,
  #price-filter-toggle:checked ~ label > span > .dropdown-examples,
  #vibe-filter-toggle:checked ~ label > span > .dropdown-examples,
  #neighborhood-filter-toggle:checked ~ label > span > .dropdown-examples,
  #lifestyle-filter-toggle:checked ~ label > span > .dropdown-examples,
  #meal-filter-toggle:checked ~ label > span > .dropdown-examples,
  #cuisine-filter-toggle--mobile:checked ~ label > span > .dropdown-examples,
  #dining-filter-toggle--mobile:checked ~ label > span > .dropdown-examples,
  #price-filter-toggle--mobile:checked ~ label > span > .dropdown-examples,
  #vibe-filter-toggle--mobile:checked ~ label > span > .dropdown-examples,
  #neighborhood-filter-toggle--mobile:checked
    ~ label
    > span
    > .dropdown-examples,
  #lifestyle-filter-toggle--mobile:checked ~ label > span > .dropdown-examples,
  #meal-filter-toggle--mobile:checked ~ label > span > .dropdown-examples {
    display: none;
  }

  .toggle {
    display: none;
  }

  button {
    margin-top: 10px;
    padding: 10px 20px;
  }

  .search-box {
    font-size: 16px;
    color: var(--off-black);
    line-height: 40px;
    padding: 0 20px;
    border: none;
    background: none;
    width: 300px;
    position: relative;

    &:focus {
      outline: none;
    }

    &::placeholder {
      font-family: var(--body-font);
      font-size: 14px;
      color: #a8a8a8;
      line-height: 40px;
    }
  }

  .close-search {
    position: relative;
    right: 20px;
    cursor: pointer;
  }

  .search-icon {
    padding-right: 16px;
    position: relative;
    top: 4px;
  }

  #search-list,
  #search-list--mobile {
    display: none;
    padding: 0 20px;

    a {
      text-decoration: none;
    }
  }

  .line {
    content: "";
    height: 1px !important;
    position: relative;
    width: 100%;
    background: #808080;
    margin-top: 20px;
    top: -1px;
  }

  .sort-filter-controls {
    height: 58px;
  }

  .restaurant-search-card {
    padding-top: 6px;
    flex-direction: row;
    height: 40px;
    overflow: hidden;
    white-space: nowrap;
    position: relative;
    cursor: pointer;

    &__container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    &__error {
      font-size: 14px;
      color: #4e4f46;
    }

    &:before {
      content: "";
      background-color: #afafaf;
      height: 1px;
      width: 100%;
      position: absolute;
      top: 0;
    }

    &:last-child {
      margin-bottom: 5px;
    }
    /* 
    &:last-child:after {
      content: none;
    } */

    &__name {
      font-size: 18px;
      margin-right: 40px;
      white-space: nowrap;
      align-items: center;
    }

    /* &__tag-text {
      font-size: 12px;
      color: #4e4f46;
      text-transform: uppercase;
      margin-right: 5px;

      &:last-child {
        margin-right: 0;
      }
    }

    &__tags {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
    } */
  }

  /* @media only screen and (max-width: 1190px) {
    #see-all {
      top: 174px;
      right: 80px;
    }
  } */

  @media only screen and (max-width: 1145px) and (pointer: coarse) {
    .done-filtering-btn--mobile {
      margin-top: 16px;
      display: block;
      width: calc(100vw - 24px);
      background-color: var(--off-black);
      color: white;
      font-family: var(--body-font);
      font-size: 20px;
      height: 57px;
      text-align: center;
      line-height: 57px;
      border-radius: 60px;
      box-shadow: 0 0 8px 0px rgba(0, 0, 0, 0.1);
    }

    .search-box {
      font-size: 16px !important;
    }

    .label-text {
      width: calc(100vw - 36px - 24px - 20px) !important;
    }

    .search-container--mobile {
      display: block;
    }

    .instructions {
      display: none;
    }

    .search-box {
      line-height: 57px;
      padding: 0 18px;
      background: none;
      width: calc(100vw - 24px);

      &:focus {
        outline: none;
      }

      &::placeholder {
        font-family: var(--body-font);
        font-size: 16px;
        color: var(--footer-med-gray);
        line-height: 57px;
      }
    }

    #sustainable-dropdown-label {
      max-width: calc(100vw - 36px - 24px);
      width: calc(100vw - 36px - 24px) !important;
    }

    #search-form--mobile {
      width: calc(100vw - 24px);
      background: white;
      /* height: 57px; */
      border-radius: 30px;
      box-shadow: 0 0 8px 0px rgba(0, 0, 0, 0.1);
      margin: 0;
      margin-bottom: 8px;
      border: none;
    }

    #search-list--mobile {
      padding-bottom: 10px;
    }

    .restaurant-search-card {
      width: calc(100vw - 60px);

      &__name {
        font-family: var(--header-font);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 18px !important;
        line-height: 26px !important;
        padding: 2px 0px 1px !important;
      }

      &__tags {
        display: none;
      }
    }

    .filters-header--mobile {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 12px 18px 8px;

      h3 {
        font-size: 24px;
        margin-bottom: 12px;
        font-family: var(--header-font);
        font-weight: normal !important;
        line-height: 30px;
      }
    }

    .dropdown-label {
      width: calc(100vw - 24px - 36px);
    }

    .dropdown-sublabel {
      margin-bottom: 24px;
    }

    .two-col-container {
      flex-direction: row;
      width: calc(100vw - 24px);
      padding: 0 18px;
    }

    .check {
      &-item {
        margin-bottom: 20px;
        flex: 1 1 calc(100% / 2 - 5px);
        max-width: calc(100% / 2 - 5px);

        &:nth-child(odd) {
          margin-right: 10px !important;
          padding-right: 0 !important;
        }

        &--values {
          flex: 1 1 calc(100% / 2 - 3px);
          max-width: calc(100% / 2 - 3px);
          white-space: nowrap;
          margin-bottom: 12px;

          &:nth-child(odd) {
            margin-right: 6px !important;
            padding-right: 0 !important;
          }

          &:nth-child(5) {
            margin-bottom: 22px !important;
          }
        }
      }

      &-label {
        width: calc(100vw - 24px - 36px / 2 - 3px);
        max-width: calc(100vw - 24px - 36px / 2 - 3px);

        &--values {
          width: calc(100vw - 24px - 36px / 2 - 3px);
        }
      }
    }
  }

  /* @media only screen and (max-width: 1075px) and (pointer: coarse) {
    .filter-sort-bar {
      &__container {
        min-width: initial;
        margin: 0 auto;
      }
    }

    .check {
      &-label {
        &-conscious {
          margin-right: 40px;
        }
      }
    }

    #search-container {
      position: absolute;
      top: 384px;
    }

    #see-all {
      position: absolute;
      top: 534px;
      right: 0;
    }

    .filters {
      display: none;
    }

    .thirteen-seventy {
      width: calc(100vw - 40px);
      max-width: 550px;
    }

    .filter-sort-bar,
    .filter-sort-bar-2 {
      width: calc(100vw - 40px);
      display: block;
      position: relative;
      top: -10px;
      z-index: 35000;
      max-width: 550px;

      &__container {
        width: calc(100vw - 40px);
        max-width: 550px;
      }

      &__instructions {
        margin-top: 40px;
      }
    }

    .sort-bar,
    .filter-sort-bar {
      &__instructions {
        width: calc(100vw - 40px);
        max-width: 550px;

        &-2 {
          width: calc(100vw - 40px);
          max-width: 550px;
        }
      }
    }

    .sort-bar {
      top: 96px;
    }

    .num-of-filters {
      position: relative;
      top: 436px;
      left: 0;
      padding-left: 21px;
      display: block;
      font-size: 16px;
      color: #757575;
      text-align: left;
      border: none;
    }

    .sort-bar {
      width: calc(100vw - 40px);
      max-width: 550px;
    }

    .dropdown {
      margin-right: 0;

      &-label {
        font-size: 18px;
        width: calc(100vw - 40px) !important;
        max-width: 550px;
      }
    }

    

    .clear-button {
      margin-right: 140px;
    }
  } */

  @media (hover: none) and (pointer: coarse) {
    .cuisine-check:checked + label:after,
    .meal-check:checked + label:after,
    .signup-check:checked + label:after,
    .lifestyle-check:checked + label:after,
    .price-check:checked + label:after,
    .vibe-check:checked + label:after,
    .neighborhood-check:checked + label:after,
    .dining-check:checked + label:after,
    .sustainable-check:checked + label:after {
      position: absolute;
      left: 2px !important;
      top: -3px;
      content: url(${checkMark});
      z-index: 99999999;
    }
  }

  @media (pointer: coarse) {
    .cuisine-check:checked + label:after,
    .meal-check:checked + label:after,
    .signup-check:checked + label:after,
    .lifestyle-check:checked + label:after,
    .dining-check:checked + label:after,
    .price-check:checked + label:after,
    .vibe-check:checked + label:after,
    .neighborhood-check:checked + label:after,
    .sustainable-check:checked + label:after {
      position: absolute;
      left: 2px !important;
      top: -3px;
      content: url(${checkMark});
      z-index: 99999999;
    }
  }

  @media (hover: none) and (pointer: coarse) {
    .sustainable-check:checked + label:after {
      position: absolute;
      left: 14px !important;
      top: 1px;
      content: url(${checkMark});
      z-index: 99999999;
    }
  }

  @media (pointer: coarse) {
    .sustainable-check:checked + label:after {
      position: absolute;
      left: 14px !important;
      top: 1px;
      content: url(${checkMark});
      z-index: 99999999;
    }
  }
`;

export default FilteringStyles;
